import React, { useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import { BodyMediumText } from '@prisjakt/ui/text/variants';
import { SortOptions } from '../../offer-list-sorting/sort-options';
import { AllFilters } from './all-filters';
import { IOfferlistFilters } from '../types';
import { StyledModal, Header } from '../styles';

export const FiltersModal: React.FC<IOfferlistFilters> = props => {
  const { closeHandler, variantGroups, conditions, categoryId } = props;
  const { t } = useContext(AppContext);

  return (
    <StyledModal
      isOpen
      onRequestClose={closeHandler}
      shouldShowCloseIcon
      width="inherit"
    >
      <Header>
        <BodyMediumText>{t('filter', 'filter.title')}:</BodyMediumText>
      </Header>
      <AllFilters
        conditions={conditions}
        variantGroups={variantGroups}
        categoryId={categoryId}
      />
      <Header>
        <BodyMediumText>{t('common', 'sort.title')}:</BodyMediumText>
      </Header>
      <SortOptions renderAllOptions />
    </StyledModal>
  );
};
